import React, { useMemo } from 'react';
import { useGetBookQuery } from '@/api/types';
import { Button, BookMedia } from '@/components';

interface StudentDecodableBookPodProps {
  bookId: string;
}

export const StudentDecodableBookPod = ({
  bookId,
}: StudentDecodableBookPodProps) => {
  const {
    data: bookResult,
    loading: bookLoading,
    error: bookError,
  } = useGetBookQuery({
    variables: {
      id: bookId,
    },
  });

  const book = useMemo(
    () =>
      bookResult?.book.__typename === 'StudioLibraryBook'
        ? bookResult.book
        : undefined,
    [bookResult],
  );

  return bookLoading ? (
    'Loading'
  ) : book ? (
    <div className="relative flex flex-col gap-3 group">
      <BookMedia
        bookCover={book.coverURL || undefined}
        altText={book.title || ''}
      />

      <div className="hidden absolute left-0 bottom-0 w-full flex-col gap-3 bg-white bg-opacity-75 p-3 group-hover:flex max-h-[50%] overflow-hidden">
        <Button href={`/read/${book.id}`}>Read now</Button>

        <div className="prose prose-h3:text-pt-primary prose-h2:font-bold">
          <h3>{book.title}</h3>

          {book.description}
        </div>
      </div>
    </div>
  ) : bookError ? (
    bookError.message
  ) : (
    'Unknown error'
  );
};
